import { inject, injectable } from "inversify";
import {
  IEmpresasFinancas,
  IEPessoasFinancas,
  IFinancasFeatureGateway,
  IObterCentroDeCustoCCResponse,
  IObterCentroDeCustoPorIdResponse
} from "../ports/FinancasFeatureGateway";
import {
  IDefaultHorizonsResponse,
  IFinancasDefaultResponse,
  IPlanosDeContasHttpResponse
} from "@/services/financas/gateways/types";
import { DITypes } from "@/core/@types/types";
import { type HttpClient } from "@/core/services/protocols/types";
import {
  FinancasDevHttpDi,
  type IFinancasDevHttp
} from "@/core/services/FinancasDevHttp";

@injectable()
export default class FinancasFeatureGatewayAdapter
  implements IFinancasFeatureGateway
{
  @inject(DITypes.FINANCAS_HTTP_CLIENT)
  private httpClient?: HttpClient;

  @inject(DITypes.INDICADORES_HTTP_CLIENT)
  private httpClientIndicadores!: HttpClient;

  @inject(FinancasDevHttpDi)
  private financasDevHttp!: IFinancasDevHttp;

  async getPlanosDeContas(
    tipo: boolean
  ): Promise<IPlanosDeContasHttpResponse | undefined> {
    if (import.meta.env.DEV) {
      const response = await this.financasDevHttp.get(
        `/api/PlanoDeContaAPI/Listar/?Tipo=${tipo}`
      );

      return {
        Data: response.Data,
        Total: response.Total || 0
      };
    }

    const response = await this.httpClient?.get<
      IPlanosDeContasHttpResponse | undefined
    >({
      url: `PlanoDeContaAPI/Listar/?Tipo=${tipo}`
    });

    if (!response?.body) return;

    return response?.body;
  }

  async obterCentroDeCustoPorId(
    id: string
  ): Promise<
    | IDefaultHorizonsResponse<IObterCentroDeCustoPorIdResponse | undefined>
    | undefined
  > {
    const response = await this.httpClientIndicadores?.get<
      IDefaultHorizonsResponse<IObterCentroDeCustoPorIdResponse | undefined>
    >({
      url: "/financas/centrodecusto/v1/obter-centros-custo-by-customer-id",
      queryParams: {
        objectid: id
      }
    });

    return response?.body;
  }

  async obterCentroDeCustoCC(): Promise<
    | IFinancasDefaultResponse<IObterCentroDeCustoCCResponse | undefined>
    | undefined
  > {
    if (import.meta.env.DEV) {
      const response = await this.financasDevHttp.get(
        "/api/CentroDeCustoAPI/ListarTodosCC/"
      );

      return {
        Data: response.Data,
        Total: response.Total || 0
      };
    }

    const response = await this.httpClient?.get<
      IFinancasDefaultResponse<IObterCentroDeCustoCCResponse | undefined>
    >({
      url: "/CentroDeCustoAPI/ListarTodosCC/"
    });

    return response?.body;
  }

  async getPessoas(): Promise<IEPessoasFinancas | undefined> {
    if (import.meta.env.DEV) {
      const response = await this.financasDevHttp.get(
        "/api/PessoaAPI/ListarQuebradoPorInscricaoEManterPessoasSemInscricao?definicao=null"
      );

      return {
        Data: response.Data,
        Total: response.Total || 0
      };
    }

    const response = await this.httpClient?.get<IEPessoasFinancas | undefined>({
      url: "/PessoaAPI/ListarQuebradoPorInscricaoEManterPessoasSemInscricao?definicao=null"
    });

    return response?.body;
  }

  async getEmpresas(): Promise<IEmpresasFinancas | undefined> {
    if (import.meta.env.DEV) {
      const response = await this.financasDevHttp.get(
        "/api/EmpresaAPI/ObterEmpresasMin/"
      );

      return {
        Data: response.Data,
        Total: response.Total || 0
      };
    }
    const response = await this.httpClient?.get<IEmpresasFinancas | undefined>({
      url: "/EmpresaAPI/ObterEmpresasMin/"
    });

    return response?.body;
  }
}
